import { render } from "./ProjectsGrid.vue?vue&type=template&id=70b201fa&scoped=true"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=70b201fa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b201fa"]])

export default __exports__